var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar",style:({
    width: (_vm.size + "px"),
    minWidth: (_vm.size + "px"),
    height: (_vm.size + "px"),
    '--background-color': _vm.fillColor,
  }),attrs:{"src":_vm.avatar,"loading":"lazy"},on:{"error":_vm.setDefaultImage}})}
var staticRenderFns = []

export { render, staticRenderFns }